import { render, staticRenderFns } from "./IssuedTaskItem.vue?vue&type=template&id=fbb36d98&scoped=true&"
import script from "./IssuedTaskItem.vue?vue&type=script&lang=js&"
export * from "./IssuedTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./IssuedTaskItem.vue?vue&type=style&index=0&id=fbb36d98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb36d98",
  null
  
)

export default component.exports